import React, { useState, useRef, useEffect } from 'react';

// Formik validation
import { useFormik } from "formik";
import * as Yup from "yup";
import { mainRequestStatusFiltered, mainRequestStatusFiltered2 } from '../../constants/holcim';
import { BaseCustomModal, BaseCustomButton, GradientDecorationLine, BaseSelectComponent } from '../../shared';

export const GenetalStatusModal = ({ props, setShowModal, showModal, modalRespInfo, requestStatus, role }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            generalStatus: requestStatus?.generalStatus ?? '',
        },
        validationSchema: Yup.object({
            generalStatus: Yup.string().required("Seleccione un estatus de atención o puede cancelar la operación"),
        }),
        onSubmit: (values, { resetForm }) => {
            setIsSubmitting(true);
            const startTime = Date.now();
            modalRespInfo(values, () => {
                // Minimum 1.5s delay to ensure the user sees the "Procesando..." state (Labor Illusion UX)
                const elapsedTime = Date.now() - startTime;
                const remainingTime = Math.max(0, 1500 - elapsedTime);
                setTimeout(() => {
                    setIsSubmitting(false);
                    setShowModal(false);
                }, remainingTime);
            }, () => {
                setIsSubmitting(false);
            });
        }
    });

    const { className } = props;

    const toggle = () => {
        setShowModal(!showModal);
    }

    const onClosed = () => {
        validation.resetForm()
        setIsSubmitting(false);
        setShowModal(false);
    }

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color='success'
                className='rounded-3 me-4'
                onClick={validation.handleSubmit}
                label={isSubmitting ? 'Procesando...' : 'Guardar'}
                disabled={isSubmitting}
                outline={true}
                icon={isSubmitting ? "mdi mdi-spin mdi-loading me-1" : "mdi mdi-content-save me-1"}
            />
            <BaseCustomButton
                color='danger'
                className='rounded-3 me-3'
                onClick={toggle}
                label='Cancelar'
                disabled={isSubmitting}
                outline={true}
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

     // Dynamic options based on `generalStatus`
    const getStatusOptions = () => {
        if (role === 'Asesor Técnico') {
        return mainRequestStatusFiltered2.map((dir) => ({ value: dir.id, label: dir.value }));
        } else {
        return (requestStatus?.generalStatus === 'Aceptada')
            ? mainRequestStatusFiltered
            : mainRequestStatusFiltered;
        }
    };

    return (
        <BaseCustomModal
        title={<h4 className='text-primary ps-4 m-0'>{'Edición de estatus general'}</h4>}
        isModalOpen={showModal}
        handleOk={validation.handleSubmit}
        handleCancel={toggle}
        className={className}
        onClosed={onClosed}
        footer={null}
        >
        <GradientDecorationLine />

        <form
            className="form-horizontal mt-3 mb-1"
            onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
            }}
        >
            <div className="mb-1 px-5">
            <label className='text-primary'>Estatus de la Solicitud</label>
            <BaseSelectComponent
                name="generalStatus"
                required
                disabled={isSubmitting}
                placeholder="Estatus de solicitud"
                onBlur={validation.handleBlur}
                value={validation.values.generalStatus || ""}
                options={getStatusOptions()}
                onChange={(value) => validation.setFieldValue("generalStatus", value)}
                error={validation.errors.generalStatus}
                touched={validation.errors.generalStatus}
                status={validation.errors.generalStatus ? "error" : ''}
            />

            {isSubmitting ? (
                <div className='text-primary text-center mt-3 fw-bold'>
                    Procesando solicitud y asignando códigos de muestra... por favor espere.
                </div>
            ) : null}

            {validation.values.generalStatus === 'Concluida' || validation.values.generalStatus === 'Cancelada' ? (
                <div>
                <div className='text-danger mt-3'>
                    Esta acción bloqueará todos los procesos de la solicitud, la acción es irreversible, antes de continuar asegurese de que todos los procesos han sido concluidos
                </div>
                <div className='text-danger text-center'>¿Desea continuar?</div>
                </div>
            ) : null}
            </div>

            <div className='mt-5'>
            <GradientDecorationLine />
            {buttons}
            </div>
        </form>

        </BaseCustomModal>
    );
};